export const SET_CART = 'checkout/SET_CART';
export const setCart = cart => ({
    type: SET_CART,
    payload: {
        cart,
    },
});

export const clearCart = () => setCart({});

export const ADD_PRODUCT = 'checkout/ADD_PRODUCT';
export const addProduct = productSlug => ({
    type: ADD_PRODUCT,
    payload: {
        productSlug,
    },
});

export const DELETE_PRODUCT = 'checkout/DELETE_PRODUCT';
export const deleteProduct = productSlug => ({
    type: DELETE_PRODUCT,
    payload: {
        productSlug,
    },
});

export const CHANGE_AMOUNT = 'checkout/CHANGE_AMOUNT';
export const changeAmount = (productSlug, amount) => ({
    type: CHANGE_AMOUNT,
    payload: {
        productSlug,
        amount,
    },
});



// WEBPACK FOOTER //
// ./resources/components/shop/actions/cart.js